import React, { FC } from 'react';

import { Container, Text } from '@lglp/components';
import { SocialNetwork } from '@lglp/prismic-client';

import styles from './FooterSocial.module.scss';
import { SocialLink } from './SocialLink';

export const FooterSocial: FC<FooterSocialProps> = ({
  title,
  socialLinks,
  className,
}) => {
  return (
    <Container className={[styles.footerSocial, className]}>
      <Text className={styles.title} body={title} />
      <Container className={styles.wrapper}>
        {socialLinks?.map(({ type, link }, idx) => (
          <SocialLink key={idx} type={type} link={link} />
        ))}
      </Container>
    </Container>
  );
};

export type FooterSocialProps = {
  title: string;
  socialLinks: SocialNetwork[];
  className?: string;
};
